// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2600":"b5189dc6","5744":"91a1d8a4","5942":"86d0b748","7174":"76873ddd","8171":"86d0b748"}[chunkId] + ".chunk.css";
};